import {useGetDiscountsInMemoryCacheClient} from './useGetDiscountsInMemoryCache.client';
import {useGetDiscountsInMemoryCacheServer} from './useGetDiscountsInMemoryCache.server';

export const useGetDiscountsInMemoryCache = process.browser
  ? useGetDiscountsInMemoryCacheClient
  : useGetDiscountsInMemoryCacheServer;
